import { render, staticRenderFns } from "./UploadDetail.vue?vue&type=template&id=664b5b72&scoped=true"
import script from "./UploadDetail.vue?vue&type=script&lang=js"
export * from "./UploadDetail.vue?vue&type=script&lang=js"
import style0 from "./UploadDetail.vue?vue&type=style&index=0&id=664b5b72&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "664b5b72",
  null
  
)

export default component.exports